import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import { text } from '../../text';
import { utils } from '../../utils';
import { theme } from '../../constants';
import { components } from '../../components';
import { course as elements } from '../../course';
import { hooks } from '../../hooks';
import properties from '../../staticdata/properties';
export const MyCourses: React.FC = () => {
  const navigate = hooks.useNavigate();
  const { pathname } = useLocation();
  const [selectedTab, setSelectedTab] = useState('Sortlisted Properties');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const getFilteredProperties = () => {
    switch (selectedTab) {
      case 'Sortlisted Properties':
        return properties.properties.filter(p => p.status === 'shortlisted');
      case 'Property visits':
        return properties.properties.filter(p => p.status === 'visit');
      case 'Property Bookings':
        return properties.properties.filter(p => p.status === 'booked');
      default:
        return properties.properties;
    }
  };
  const renderImageBackground = (): JSX.Element => {
    return <components.Background version={1} />;
  };
  const renderHeader = (): JSX.Element => {
    return <components.Header title="My Properties" />;
  };
  const renderTabs = (): JSX.Element => {
    const tabs = ['Sortlisted Properties', 'Property visits', 'Property Bookings'];
    return (
      <div style={{ marginTop: 8, marginBottom: 20 }}>
        <Swiper spaceBetween={16} slidesPerView="auto" style={{ paddingLeft: 16 }}>
          {tabs.map((tab) => (
            <SwiperSlide key={tab} style={{ width: 'auto' }}>
              <button
                style={{
                  padding: '8px 16px',
                  border: 'none',
                  borderBottom:
                    tab === selectedTab ? '2px solid #111111' : '2px solid #E7E6E7',
                  fontFamily: tab === selectedTab ? 'Lato-Bold' : 'Lato-Regular',
                  fontSize: 14,
                  background: 'transparent',
                  color:
                    tab === selectedTab
                      ? theme.colors.mainColor
                      : theme.colors.secondaryTextColor,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
                onClick={() => setSelectedTab(tab)}
              >
                {tab}
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  };
  const renderPropertiesList = (): JSX.Element => {
    const filteredProperties = getFilteredProperties();
    return (
      <div style={{ marginTop: 20 }}>
        {filteredProperties.map((property) => (
          <div style={{ marginBottom: 0, marginTop: 40 }}>

            {properties?.properties.slice(0, 3).map((course: any, index, array) => {
              const isLast = index === array.length - 1;

              return (
                <elements.CourseCard
                  key={course.id}
                  course={course}
                  isLast={isLast}
                  section='top rated'
                />
              );
            })}

          </div>
        ))}
      </div>
    );
  };

  const renderPropertiesGrid = (): JSX.Element => {
    const filteredProperties = getFilteredProperties();

    const groupedRows = filteredProperties.reduce((rows: any[][], prop, index) => {
      const rowIndex = Math.floor(index / 2);
      if (!rows[rowIndex]) rows[rowIndex] = [];
      rows[rowIndex].push(prop);
      return rows;
    }, []);

    return (
      <div style={{ marginTop: 20 }}>
        {groupedRows.map((row, rowIndex) => (
          <div
            key={rowIndex}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 20,
              gap: 12,
            }}
          >
            {row.map((property) => (
              <div
                key={property.id}
                onClick={() => navigate('/course-details', { state: { course: property } })}
                style={{
                  width: '48%',
                  borderRadius: 10,
                  overflow: 'hidden',
                  backgroundColor: '#F9F9F9',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                  cursor: 'pointer',
                }}
              >
                <img
                  src={property.preview_90x90}
                  alt={property.name}
                  style={{
                    width: '100%',
                    height: 120,
                    objectFit: 'cover',
                  }}
                />
                <div style={{ padding: 10 }}>
                  <text.T16
                    style={{ ...theme.fonts.Lato_700Bold, color: '#000', marginBottom: 4 }}
                  >
                    {property.name}
                  </text.T16>
                  <text.T14 style={{ color: theme.colors.secondaryTextColor }}>
                    ${property.price?.toFixed(2)} / Month
                  </text.T14>
                  <text.T14 style={{ color: '#555', marginTop: 4 }}>
                    London University
                  </text.T14>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const renderBottomTabBar = (): JSX.Element => {
    return <components.BottomTabBar />;
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className="container">
        {renderTabs()}
        {renderPropertiesList()}
      </main>
    );
  };

  return (
    <>
      {/*  */}
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};
